import type { WorkflowFeedback } from '../../../shared/domain/workflowFeedback/types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'PATCH', pattern: '/api/workflows/feedbacks/:feedbackId' }

type Params = {
    feedbackId: UUID
}
type Body = Partial<Omit<WorkflowFeedback, 'id'>>
type Query = never
type Output = WorkflowFeedback

export type UpdateEndpoint = Endpoint<Params, Body, Query, Output>

export const updateRequest = (request: Request, args: RequestArgs<UpdateEndpoint>) =>
    request<UpdateEndpoint>(route, args)
